import React from "react";
import "./projects.css";

import Portfolio from "../../assets/mainImage.png";
import TextUtils from "../../assets/portfolio2.png";
// import Ecommerce from "../../assets/portfolio3.jpg";
// import Binary_Food from "../../assets/portfolio4.png";
import Netflix from "../../assets/netflix.png";
import Mflix from "../../assets/mflix.png";

const data = [
  {
    id: 1,
    image: Portfolio,
    techstack: "HTML | CSS | JavaScript | React Js",
    title: "Personal Portfolio - Website",
    github: "https://github.com/raahul131/",
    demo: "https://rahulray.vercel.app/",
  },
  {
    id: 2,
    image: Netflix,
    techstack: "TypeScript | Tailwind CSS | React Js ",
    title: "Netflix - Website",
    github: "https://github.com/raahul131/Netflix7",
    demo: "https://movieflix131.vercel.app/",
  },

  {
    id: 3,
    image: TextUtils,
    techstack: "HTML | CSS | JavaScript | Bootstrap 5",
    title: "Text Utils - Website",
    github: "https://github.com/raahul131/Text-Utils",
    demo: "https://textutils7.vercel.app/",
  },
  {
    id: 4,
    image: Mflix,
    techstack: "JavaScript | Tailwind CSS | React Js",
    title: "Mflix - Website",
    github: "https://github.com/raahul131/api_movie_app",
    demo: "https://mflix7.vercel.app/",
  },
  // {
  //   id: 5,
  //   image: Binary_Food,
  //   techstack: "HTML | CSS | JavaScript | React Js | Redux",
  //   title: "Hamro Food - Website",
  //   github: "https://github.com/raahul131/Binary-food",
  //   demo: "https://binaryfood.vercel.app/",
  // },
  // {
  //   id: 5,
  //   image: TextUtils,
  //   techstack: "HTML | CSS | JavaScript | Bootstrap 5",
  //   title: "Text Utils - Website",
  //   github: "https://github.com/raahul131/Text-Utils",
  //   demo: "https://textutils7.vercel.app/",
  // },
  // {
  //   id: 6,
  //   image: TextUtils,
  //   techstack: "HTML | CSS | JavaScript | Bootstrap 5",
  //   title: "Text Utils - Website",
  //   github: "https://github.com/raahul131/Text-Utils",
  //   demo: "https://textutils7.vercel.app/",
  // },
  // {
  //   id: 4,
  //   image: Ecommerce,
  //   techstack: "HTML | CSS | JavaScript | React Js | Next Js | Sanity",
  //   title: "Ecommerce - Website",
  //   github: "https://github.com/raahul131/E-Commerce_Website_Sanity",
  //   demo: "https://flipout.vercel.app/",
  // },
];

const Projects = () => {
  return (
    <section id="projects">
      <h5>My Recent Works</h5>
      <h2>Projects</h2>
      <div className="container projects__container">
        {data.map((element) => {
          return (
            <article key={element.id} className="projects__item">
              <div className="projects__item-image">
                <img src={element.image} alt="" />
              </div>
              <h3>{element.title}</h3>
              <h4 className="text-light">{element.techstack}</h4>
              <div className="projects__item-cta">
                <a
                  target={"_blank"}
                  href={element.github}
                  rel="noreferrer"
                  className="btn"
                >
                  Github
                </a>
                <a
                  target={"_blank"}
                  href={element.demo}
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
      <div className="more-btn">
        <a
          href="https://github.com/raahul131"
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary"
        >
          More Projects
        </a>
      </div>
    </section>
  );
};

export default Projects;
